import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import {FormattedMessage} from "react-intl";
import {formatMoney} from "@/utils/MoneyUtils";
import {Alert} from "peggirkit";

type Props = {
    order: PlacedOrderOverview,
};

/**
 * Paid online, with what the customer has to pay extra or gets back when
 * the order was changed afterwards.
 */
const OnlinePayment = ({order}: Props) => (
    <div className={"flex flex-col items-start gap-3"}>
        <p>
            <FormattedMessage id={"paidOnline"}/>
            {
                order.amountPaidOnline !== null &&
                <>: <span className={"tabular-nums"}>{formatMoney(order.amountPaidOnline)}</span></>
            }
        </p>

        {
            order.amountToPayInPerson > 0 &&
            <Alert
                type={"warning"}
                title={<FormattedMessage id={"customerPaysExtra"}
                                         values={{amount: formatMoney(order.amountToPayInPerson)}}/>}
                content={<FormattedMessage id={"customerPaysExtraDescription"}/>}
            />
        }

        {
            order.amountToRefund > 0 &&
            <Alert
                type={"danger"}
                title={<FormattedMessage id={"customerGetsRefund"}
                                         values={{amount: formatMoney(order.amountToRefund)}}/>}
                content={<FormattedMessage id={"customerGetsRefundDescription"}/>}
            />
        }
    </div>
);

export default OnlinePayment;